export const SET_VIDEO_CATEGORIES = 'SET_VIDEO_CATEGORIES';
